import hubConnection from '@api/connection/hubConnection';

export default hubConnection;
